// Funzione per calcolare il conteggio personalizzato del carrello
function getCustomCartCount() {
  return fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      let customCartCount = cart.item_count;
      cart.items.forEach(item => {
        // Se il prezzo dell'articolo è 0, sottrai la sua quantità
        if (item.price === 0) {
          customCartCount -= item.quantity;
        }
      });
      return customCartCount;
    });
}

// Funzione per aggiornare l'icona del carrello
function updateCartCountUI() {
  getCustomCartCount().then(count => {
    const cartCountBubble = document.getElementById('cart-icon-bubble');
    if (cartCountBubble) {
      const visibleSpan = cartCountBubble.querySelector('span:not(.visually-hidden)');
      const visuallyHiddenSpan = cartCountBubble.querySelector('.visually-hidden');
      if (visibleSpan) {
        visibleSpan.textContent = count;
      }
      if (visuallyHiddenSpan) {
        visuallyHiddenSpan.textContent = window.Shopify.t('sections.header.cart_count', { count: count });
      }
    }
  });
}

// Ascolta gli eventi di aggiornamento del carrello e aggiorna il conteggio
document.addEventListener('DOMContentLoaded', () => {
  updateCartCountUI();
  subscribe('cart-update', updateCartCountUI); // Aggiorna il conteggio quando il carrello viene modificato
});